module.exports = __webpack_public_path__ + "img/uob.8bb81a80.svg";